module.exports = __webpack_public_path__ + "static/media/shareIcon.bdf82e3e.svg";